import { ProductColor } from '../../__generated__/graphql/catalog/graphql'

type LikeColorGroup = { colors: Pick<ProductColor, 'rawName'>[] }

/* Check if a given color key exists as an option in any of the provided color groups. */
export function existsInColorGroups<T extends LikeColorGroup>(
  colorKey: string,
  ...colorGroups: T[]
): boolean {
  return colorGroups.some(colorGroup => colorGroup.colors.some(color => color.rawName === colorKey))
}
